import {
  Box,
  Flex,
  HStack,
  Text,
} from '@chakra-ui/react';
import {
  useInvestmentAuditKPI, useTechnicalAuditKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { TRAFFIC_LIGHT_COLOURS as COLOURS } from '@src/modules/performance/shared/constants';
import ReportHeader from './ReportHeader';
import { mapValueToColourRange } from '../../../../shared/helpers';

const subheader = 'Investment Performance';
const informationSource = {
  title: 'Co-Investor Assurance',
  content: [
    {
      title: 'Procedural and Technical Audit Overview',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      Results from the latest investment audits carried out by NZTA under Section 95(1)(e)(ii) of the Land Transport Management Act 2003. Two types of audits are typically undertaken and two separate audit reports are produced. Typically, a technical audit is undertaken before the procedural audit. Historically in some cases, the two reports were combined and were referred to as a Technical and Procedural Audit.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Over time the subject areas of each audit have been refined. The subject areas outlined are the latest, and the titles and the grading in the Territorial Authority report may vary to reflect the methodology at the time of the audit.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Outdated audits results before 1 July 2015 are not included in the RCA reports.
    </Text>
    <Text fontSize="inherit" mb={2}>
      In some cases, the latest results included in the RCA report are more recent than the RCA report period.
    </Text>
    <Text fontSize="inherit">
      The overall assessment results for procedural and technical audits. Result displayed separately when the two audits are undertaken individually, or as a single &apos;overall rating&apos; result in the instance of a combined audit.
    </Text>
  </>,
      source: <Text fontSize="inherit">Sourced from NZTA Audit and Assurance, Corporate Services</Text>,
    },
  ],
};

function CoInvestorAssuranceReportHeader({ ...rest }) {
  const { data: investmentAuditKPI, isLoading: isloadingInvestment } = useInvestmentAuditKPI();
  const { data: technicalAuditKPI, isLoading: isloadingTechnical } = useTechnicalAuditKPI();
  const isLoading = isloadingInvestment || isloadingTechnical;

  return (
    <ReportHeader
      title="Co-Investor Assurance"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <HStack spacing={4} align="center">
        <Flex align="center">
          <Box mr={3}>
            <CircleIndicator
              size={60}
              colour={COLOURS[mapValueToColourRange(parseFloat(investmentAuditKPI?.score), 'coassurance')]}
              value={null}
              isLoading={isLoading}
            />
          </Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Procedural
            <br />
            <Text as="span" fontSize="xs" color="gray">
              (
              {investmentAuditKPI?.date}
              )
            </Text>
          </Text>
        </Flex>
        <Flex align="center">
          <Box mr={3}>
            <CircleIndicator
              size={60}
              colour={COLOURS[mapValueToColourRange(parseFloat(technicalAuditKPI?.score), 'coassurance')]}
              value={null}
              isLoading={isLoading}
            />
          </Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Technical
            <br />
            <Text as="span" fontSize="xs" color="gray">
              (
              {technicalAuditKPI?.date}
              )
            </Text>
          </Text>
        </Flex>
      </HStack>
    </ReportHeader>
  );
}

export default CoInvestorAssuranceReportHeader;
